var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header"},[_c('div',{staticClass:"page-header__item"},[_c('UILogo')],1),_c('div',{staticClass:"page-header__item"},[_c('PageNav'),_c('UISwitchTheme')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }